// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sticky-preview[data-v-cd0e5292]{position:sticky;top:0!important;-ms-flex-item-align:start;align-self:flex-start;height:-webkit-max-content;height:-moz-max-content;height:max-content;z-index:10}[dir=rtl] .contentinfo[data-v-cd0e5292],[dir=rtl] .rowinfo[data-v-cd0e5292]{text-align:right}[dir=ltr] .contentinfo[data-v-cd0e5292],[dir=ltr] .rowinfo[data-v-cd0e5292]{text-align:left}", ""]);
// Exports
module.exports = exports;
